// extracted by mini-css-extract-plugin
export default {"messagesContainer":"ConversationWindow_messagesContainer__oKQYL"};